"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapQueryFields = exports.validator = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _validator = _interopRequireDefault(require("validator"));

var _lodash = _interopRequireDefault(require("lodash.set"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var funcs = Object.entries(_validator.default).filter(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      fn = _ref2[1];

  return typeof fn === 'function';
}).map(function (_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      fn = _ref4[1];

  return _defineProperty({}, key, function () {
    for (var _len = arguments.length, options = new Array(_len), _key = 0; _key < _len; _key++) {
      options[_key] = arguments[_key];
    }

    return function (str) {
      return fn.apply(void 0, [str].concat(options));
    };
  });
});
var validator = Object.assign.apply(Object, [{
  isDate: function isDate() {
    return function (str) {
      return (0, _moment.default)(str, 'YYYY-MM-DD').isValid();
    };
  },
  isTime: function isTime() {
    return function (str) {
      return (0, _moment.default)(str, 'HH:mm').isValid();
    };
  }
}].concat(_toConsumableArray(funcs)));
exports.validator = validator;

var mapQueryFields = function mapQueryFields(fields, mapping) {
  var data = {};
  Object.entries(mapping).forEach(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        key = _ref7[0],
        rule = _ref7[1];

    var valid = rule.validator,
        sanitizer = rule.sanitizer,
        stateField = rule.stateField;
    var value = fields[key];

    if (value === undefined) {
      return {};
    }

    if (valid && !valid(value)) {
      throw new Error("Failed to validate query field: ".concat(key, " = ").concat(value));
    }

    value = sanitizer ? sanitizer(value) : value;

    if (typeof stateField === 'string') {
      (0, _lodash.default)(data, stateField, value);
    } else {
      stateField.parse(value, data);
    }
  });
  return data;
};

exports.mapQueryFields = mapQueryFields;